<template>
  <team-form
    :title="$t('string.edit_team')"
  />
</template>

<script>
import TeamForm from './Form'

export default {
  name: 'Edit',
  metaInfo () {
    return {
      title: this.$t('string.edit_team'),
      titleTemplate: '%s | ' + process.env.VUE_APP_NAME
    }
  },
  components: { TeamForm }
}
</script>

<style scoped>

</style>
